import { usePageTopBar } from '@/app/layouts/pageTopBar';
import type { Tab } from '../types';
import { Posting } from '../Posting';

export function PostingPage({ view }: { view: Tab }) {
  usePageTopBar({ breadcrumb: ['Posting'] });
  return <Posting view={view} />;
}
